import React from "react";
import ExpenseList from "./ExpenseList";
import ExpenseListFilters from "./ExpenseListFilters";
import ExpensesSummary from './ExpensesSummary';
import { Link } from "react-router-dom";

const ExpenseDashboardPage = () => (
    <div className="expense_overview">
        <ExpensesSummary />
        <ExpenseListFilters />
        <ExpenseList />
        <div>
            <div className="page-header__actions">
                <Link className="button add_expense" to="/create">Add Expense</Link>
                <Link className="button view_profile" to="/profile">Profile Settings</Link>
            </div>
        </div>
    </div>
);

export default ExpenseDashboardPage;


// WEBPACK FOOTER //
// ./src/components/ExpenseDashboardPage.js